// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { SpModalFilters } from './sp-modal-filters';

export class SpFilterModel {
  public constructor(
    public searchInput: string,
    public modalFilters: SpModalFilters,
  ) {}
}
